// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"563":"1d645fe9","778":"8df39935","787":"28cb0dcd"}[chunkId] + ".chunk.js";
};